import type { ReactNode } from "react";
import { X } from "lucide-react";
import { Button } from "./ui/button";
import { cn } from "@/lib/utils";

// Menu lateral em drawer no mobile (<lg). Recebe o <Sidebar> como children — a fence do Sidebar
// (sidebar.tsx + o bloco <Sidebar> em AppLayout) permanece intocada.
export function AppMobileDrawer({
  open,
  onClose,
  children,
}: {
  open: boolean;
  onClose: () => void;
  children: ReactNode;
}) {
  return (
    <div
      className={cn(
        "fixed inset-0 z-40 lg:hidden",
        open ? "pointer-events-auto" : "pointer-events-none"
      )}
      aria-hidden={!open}
    >
      {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions -- backdrop overlay; teclado fecha via Escape gerenciado no portal pai */}
      <div
        className={cn(
          "absolute inset-0 bg-[oklch(20%_0.01_80_/_0.4)] transition-opacity",
          open ? "opacity-100" : "opacity-0"
        )}
        onClick={onClose}
      />
      <div
        className={cn(
          "absolute inset-y-0 left-0 transition-transform",
          open ? "translate-x-0" : "-translate-x-full"
        )}
        role="dialog"
        aria-modal="true"
        aria-label="Menu lateral"
      >
        {children}
        <Button
          variant="ghost"
          size="icon"
          className="absolute right-2 top-2 text-text-inverse hover:bg-bg-inverse-muted"
          onClick={onClose}
          aria-label="Fechar menu"
        >
          <X className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
}
